import { UpdatePackagesState } from "./state";
import { UpdatePackageInstallationsCount } from "@/model/data/updates/UpdatePackageInstallationsCount";

export const SET_UPDATE_PACKAGES_LIST_FETCHING = "SET_UPDATE_PACKAGES_LIST_FETCHING";
export const SET_UPDATE_PACKAGES_LIST = "SET_UPDATE_PACKAGES_LIST";


export default {

    [SET_UPDATE_PACKAGES_LIST_FETCHING](state: UpdatePackagesState, value: boolean) {
        state.isUpdatePackagesListFetching = value;
    },

    [SET_UPDATE_PACKAGES_LIST](state: UpdatePackagesState, updatePackages: UpdatePackageInstallationsCount[]) {
        state.updatePackagesList = updatePackages;
    }
}